export const selectMoreOptions = [
  { value: 'Tags', label: 'Add Tag' },
  { value: 'Priority', label: 'Add Priority' },
];

export const priorityOptions = [
  { value: 'High', label: 'High' },
  { value: 'Medium', label: 'Medium' },
  { value: 'Low', label: 'Low' },
];

export const defaultFilterOptions = [
  { value: 'PINNED', label: 'Pinned' },
  { value: 'STATUS', label: 'Status' },
  { value: 'ALL NOTES', label: 'Clear' },
  { value: 'PRIORITY', label: 'Priority' },
];

export const statusOptions = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'TRASH', label: 'Trash' },
  { value: 'ARCHIVE', label: 'Archive' },
];

export const DROPDOWN_COLORS = 'Colors';
export const DROPDOWN_OPTIONS = 'Options';
export const DROPDOWN_TAGS = 'Tags';
export const DROPDOWN_PRIORITY = 'Priority';
export const DROPDOWN_STATUS = 'Status';
export const DROPDOWN_FILTER = 'All Notes';
export const DROPDOWN_CLEAR = 'Clear';
export const DROPDOWN_PINNED = 'Pinned';
